import { useIsMlOrGreater, useIsSmOrSmaller } from '@dreamstack/feature-components/src/hooks/useWindowSize'
import {
  FullGridWidthDiv,
  GridWithGaps,
  MainGridStyled,
} from '@dreamstack/feature-components/src/layout/MainGrid'

import { BlockHighlightRealEstate } from '@dreamstack/payload/src/payload-types'
import type { FunctionComponent } from 'react'
import { useState } from 'react'
import { BigTitleNavigation } from './BigTitleNavigation'
import { HighlightRealEstateItem } from './HighlightRealEstateItem'
import { HighlightRealEstatePageNumber } from './HighlightRealEstatePageNumber'

export const HighlightReel: FunctionComponent<
  React.PropsWithChildren<{
    block: BlockHighlightRealEstate
  }>
> = ({ block }) => {
  const realEstates = block?.entries
  const isSm = useIsSmOrSmaller()
  const isMl = useIsMlOrGreater()
  const [activeIndex, setActiveIndex] = useState(0)
  return (
    <GridWithGaps className="col-span-full">
      <FullGridWidthDiv className="col-span-full bg-accentroAquaVeryLight-full top-0 h-[250px] md:h-[250px] md:z-20 md:sticky ml:h-[550px] ml:z-auto lg:h-[650px]">
        <MainGridStyled className="col-span-full h-full">
          <div className="flex items-center col-span-full md:col-span-11 ml:max-w-[490px] lg:max-w-none lg:col-span-3 lg:z-auto">
            <div className="w-full">
              <BigTitleNavigation
                displayAsColumn={isMl || isSm}
                block={block.bigTitleNavigation[0] ?? undefined}
              />
            </div>
          </div>
        </MainGridStyled>
      </FullGridWidthDiv>
      <FullGridWidthDiv className="col-span-full bg-accentroAquaVeryLight-full hidden md:block md:h-[366px] md:top-[150px] md:z-[9] md:sticky ml:top-[550px] ml:h-[108px] lg:top-[650px]">
        <MainGridStyled className="col-span-full h-full">
          <div className="hidden md:flex md:items-end md:col-start-12 md:col-span-1 md:justify-center md:z-10 md:max-h-min ml:col-span-1 ml:col-start-12 ml:pr-0">
            <HighlightRealEstatePageNumber
              length={realEstates?.length ?? 0}
              index={activeIndex}
            />
          </div>
        </MainGridStyled>
      </FullGridWidthDiv>
      <div className="z-10 col-span-full space-y-px-48 mt-px-48 md:col-span-11 md:-mt-[366px] md:mb-px-32 md:space-y-px-80 ml:col-start-6 ml:col-span-6 ml:-mt-[490px] lg:-mt-[560px]">
        {realEstates?.map((_, i) => {
          return (
            <HighlightRealEstateItem
              key={i}
              index={i}
              block={block}
              setActiveIndex={setActiveIndex}
            />
          )
        })}
      </div>
    </GridWithGaps>
  )
}
